import { Axios } from "../hooks/useAxiosInstance";

export const UserManagement = (function () {

    // const { api_token } = useSelector(state => state.profile);

    const apis = () => ({
        fetch: async ({ api_token }) => await fetchRecord(api_token),
        update: async (user_slug, api_token) => await updateRecord(user_slug, api_token),
    })

    async function fetchRecord(api_token) {
        const url = "admin/users";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.get(url, option);
    }

    async function updateRecord(user_slug, api_token) {
        const url = "admin/users/" + user_slug;
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'application/json'
            }
        }

        return await Axios.patch(url, {}, option);
    }


    return apis();

})()
